export default {log: console.log};
